<!--
  This is a temporary component to display the affected system items in a test page.
-->
<template>
  <div v-if="items && items.length > 0">
    <!-- eslint-disable-next-line vue/require-v-for-key -->
    <div v-for="(items, referenceName) in groupedItems" class="reference-list">
      <h5>{{ referenceName }}</h5>
      <div v-for="item in items" :key="item.displayName">
        <a :href="item.fields.url.value" target="_blank" rel="noopener noreferrer">
          {{ item.fields.url.value }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CIS-Resource-Advisory-Reference',
  props: {
    items: {
      type: Array
    }
  },
  computed: {
    groupedItems: function () {
      let grouped = this.items.reduce(function (r, a) {
        r[a.fields.referenceName.value] = r[a.fields.referenceName.value] || [];
        r[a.fields.referenceName.value].push(a);
        return r;
      }, Object.create(null));

      let sorted = Object.keys(grouped)
        .sort()
        .reduce(function (acc, key) {
          acc[key] = grouped[key];
          return acc;
        }, {});

      return sorted;
    }
  }
};
</script>
